import { BREAK_GLASS_APPROVED_EVENT, BREAK_GLASS_EVENT, ENDPOINTS } from "config/constants";

let approvedSiteIds: string[] = [];
const listeners = new Set<() => void>();

export function getApprovedBreakGlassSiteIds(): string[] {
  return approvedSiteIds.slice();
}

export function setApprovedBreakGlassSiteIds(ids: string[]) {
  approvedSiteIds = (ids || []).map(String).filter(Boolean);
  listeners.forEach((fn) => fn());
}

export function isBreakGlassApproved(siteId?: string | null): boolean {
  if (!siteId) return false;
  return approvedSiteIds.includes(String(siteId));
}

export function subscribeBreakGlassApproved(listener: () => void): () => void {
  listeners.add(listener);
  return () => listeners.delete(listener);
}

/** Open the global break-glass modal, optionally pre-selecting a site. */
export function requestBreakGlass(siteId?: string | null) {
  if (typeof window === "undefined") return;
  window.dispatchEvent(
    new CustomEvent(BREAK_GLASS_EVENT, {
      detail: siteId ? { siteId: String(siteId) } : {}
    })
  );
}

/**
 * For super-admins: return true if the site is already unlocked this session.
 * Otherwise open break-glass for that site and return false (caller should not proceed yet).
 * Non-super always returns true.
 */
export function ensureBreakGlassForSite(
  userType: string | undefined,
  siteId: string | undefined | null
): boolean {
  if (userType !== "super") return true;
  if (!siteId) return true;
  if (isBreakGlassApproved(siteId)) return true;
  requestBreakGlass(siteId);
  return false;
}

export async function refreshBreakGlassApproved(fetchJson: (url: string) => Promise<any>): Promise<string[]> {
  try {
    const res = await fetchJson(ENDPOINTS.breakGlass);
    const ids = (res?.data?.siteIds || []).map(String);
    setApprovedBreakGlassSiteIds(ids);
    return ids;
  } catch (err) {
    return getApprovedBreakGlassSiteIds();
  }
}

export { BREAK_GLASS_APPROVED_EVENT, BREAK_GLASS_EVENT };
